(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-magazine"]) return;
  try {
    
  (function () {
    function buildToc() {
      var content = document.getElementById('am-content');
      var toc = document.getElementById('am-toc');
      if (!content || !toc) return;
      var heads = content.querySelectorAll('h2, h3');
      if (heads.length < 2) return;
      var list = toc.querySelector('.am__toc-list');
      for (var i = 0; i < heads.length; i++) {
        var h = heads[i];
        if (!h.id) h.id = 'am-sec-' + i;
        var li = document.createElement('li');
        li.className = 'am__toc-item am__toc-item--' + h.tagName.toLowerCase();
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
      }
      toc.hidden = false;
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', buildToc);
    } else {
      buildToc();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
